// extracted by mini-css-extract-plugin
export default {"root":"RadioButton_root__LrTmC","input":"RadioButton_input__n1Kx0","icon":"RadioButton_icon__I0LsB","dot":"RadioButton_dot__l1GF+","label":"RadioButton_label__-VTlS"};